import kotlinx.browser.localStorage
import kotlinx.browser.window
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit
import react.create
import react.dom.client.createRoot
import web.dom.document

val urlAddress = "https://my-reference.ru/"
//    val urlAddress = "http://127.0.0.1:61080/"

fun main() {
    val container = document.createElement("div")
    document.body.appendChild(container)

    val token = localStorage.getItem("accessToken")


    if (token != null) {
        window.fetch(urlAddress + "checkToken", RequestInit(
            method = "GET",
            headers = Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response ->
                if (response.ok) {
                    response.text().then {
                        if (it == "Token is valid") {
                            val welcome = Welcome.create {}
                            createRoot(container).render(welcome)
                        } else {
                            val login = LoginPage.create {}
                            createRoot(container).render(login)
                        }
                    }
                } else {
                    val login = LoginPage.create {}
                    createRoot(container).render(login)
                }
                response
            }

    } else {
        console.error("else")
        val login = LoginPage.create {}
        createRoot(container).render(login)
    }

}